var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { spacing } from '../../../defaultTheme';
import InsetSpacer from './subcomponents';
const Inset = (_a) => {
    var { respondToBreakpoints, all, vertical, horizontal, top, left, bottom, right, hideOnBreakpointUp, hideOnBreakpointDown, hideOnlyOnBreakpoints, children, debug } = _a, props = __rest(_a, ["respondToBreakpoints", "all", "vertical", "horizontal", "top", "left", "bottom", "right", "hideOnBreakpointUp", "hideOnBreakpointDown", "hideOnlyOnBreakpoints", "children", "debug"]);
    const hideProps = {};
    if (hideOnBreakpointUp) {
        hideProps.hideOnBreakpointUp = hideOnBreakpointUp;
    }
    if (hideOnBreakpointDown) {
        hideProps.hideOnBreakpointDown = hideOnBreakpointDown;
    }
    if (hideOnlyOnBreakpoints) {
        hideProps.hideOnlyOnBreakpoints = hideOnlyOnBreakpoints;
    }
    const isSizeSet = all || vertical || horizontal || top || left || bottom || right || false;
    const defaultSpace = !isSizeSet ? spacing.base : 0;
    const allSpace = spacing[all];
    const verticalSpace = spacing[vertical];
    const horizontalSpace = spacing[horizontal];
    const size = {
        top: spacing[top] || horizontalSpace || allSpace || defaultSpace,
        left: spacing[left] || verticalSpace || allSpace || defaultSpace,
        bottom: spacing[bottom] || horizontalSpace || allSpace || defaultSpace,
        right: spacing[right] || verticalSpace || allSpace || defaultSpace
    };
    return (React.createElement(InsetSpacer, Object.assign({ debug: debug, respondToBreakpoints: respondToBreakpoints }, size, hideProps, props), children || null));
};
export default Inset;
